import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { abandonProcessingSession } from "./schema/abandon-processing-session";
import { completeProcessingSession } from "./schema/complete-processing-session";
import { createProcessingSession } from "./schema/create-processing-session";
import { generateLicensePlate } from "./schema/generate-license-plate";
import { getPrinters } from "./schema/get-printers";
import { getProcessingSession } from "./schema/get-processing-session";
import { getReturnForProcessing } from "./schema/get-return-for-processing";
import { updateProcessingSessionItem } from "./schema/update-processing-session-item";

export const rpcDefinition = {
  getReturnForProcessing,
  getProcessingSession,
  createProcessingSession,
  updateProcessingSessionItem,
  completeProcessingSession,
  abandonProcessingSession,
  generateLicensePlate,
  getPrinters,
};

export type RedoReturnsProcessingRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
